import Activities from "@/components/Activities";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const ActivitiesPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <Activities />
      <Footer />
    </div>
  );
};

export default ActivitiesPage;